/**
 * User tier constants and type
 * Reference: Shared/common/src/utils/tier-utils.ts (Keep in sync)
 */
export const TIER = {
  FREE: 'free',
  PRO: 'pro',
  PREMIUM: 'premium',
  ADMIN: 'admin',
} as const;

export type Tier = typeof TIER[keyof typeof TIER];

export const TIER_DISPLAY = {
  [TIER.FREE]: 'FREE',
  [TIER.PRO]: 'PRO',
  [TIER.PREMIUM]: 'PREMIUM',
  [TIER.ADMIN]: 'ADMIN',
};

export const getTierDisplay = (tier?: string): string => {
  if (!tier) return TIER_DISPLAY[TIER.FREE];
  const normalizedTier = tier.toLowerCase();
  if (normalizedTier === 'admin') return TIER_DISPLAY[TIER.ADMIN];
  if (normalizedTier === 'premium') return TIER_DISPLAY[TIER.PREMIUM];
  if (normalizedTier === 'pro') return TIER_DISPLAY[TIER.PRO];
  return TIER_DISPLAY[TIER.FREE];
};
